import { makeStyles } from "@material-ui/styles";
import { fade } from "@material-ui/core/styles/colorManipulator";

export default makeStyles(theme => ({
  logoBox: {
    float: 'right',
    margin: '10px 5px 1px 5px',
   // backgroundColor:"#fff",

    whiteSpace: "nowrap",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  logotype: {
    color: theme.palette.primary.main,
    // marginRight: theme.spacing(1),
    fontWeight: 'bold',
    fontSize: 14,

  },
  version: {
    fontSize: 10,
    textAlign: 'right',
    float: 'right',
    marginTop: '-3px'
  }
}));
